module.exports = __webpack_public_path__ + "img/report-info.5be06247.png";